<template>
  <label
    class="text"
    :class="rootClasses"
  >
    <span class="text__label">{{ title }}</span>
    <input-mask
      class="text__input phone"
      :class="{ placeholder: isShowPlaceholder }"
      input-mode="tel"
      :unmasked="modelValue"
      :lazy="false"
      mask="{+7} (000) 000-0000"
      @focus="onFocus"
      @blur="onBlur"
      @update:unmasked="onUpdateModelValue"
    />
    <p
      v-for="violationText in violations"
      :key="violationText"
      class="text__violation"
      role="alert"
    >{{ violationText }}</p>
  </label>
</template>

<script>
import { IMaskComponent } from "vue-imask";

/**
 * @description Название события обновления значения.
 * @type {string}
 */
const NAME_EVENT_UPDATE_MODEL_VALUE = 'update:model-value';

export default {
  emit: [NAME_EVENT_UPDATE_MODEL_VALUE],
  components: {
    InputMask: IMaskComponent
  },
  props: {
    modelValue: { required: true, type: String },
    title: { default: '', type: String },
    violations: { default: () => [], type: Array },
  },
  data() {
    return {
      isFocused: false
    }
  },
  computed: {
    /**
     * @description Имеет нарушения.
     * @type {boolean}
     */
    hasViolations() {
      return this.violations.length > 0;
    },
    /**
     * @description Список классов корневого элемента.
     * @type {string[]}
     */
    rootClasses() {
      const list = [];
      if (this.hasViolations) {
        list.push('invalid');
      }
      return list;
    },
    isShowPlaceholder() {
      const isEmpty = this.modelValue.length <= 2;
      return this.isFocused !== true && isEmpty;
    }
  },
  methods: {
    onUpdateModelValue(value) {
      this.$emit(NAME_EVENT_UPDATE_MODEL_VALUE, value);
    },
    onFocus() {
      this.isFocused = true;
    },
    onBlur() {
      this.isFocused = false;
    },
  }
}
</script>

<style>
.text__input.phone {
  color: var(--reading-color);
}
.text__input.phone.placeholder {
  color: var(--unfocus-color);
}
</style>